import { render, staticRenderFns } from "./cmpvisualizadorestoque.vue?vue&type=template&id=2ddad63f&"
import script from "./cmpvisualizadorestoque.vue?vue&type=script&lang=js&"
export * from "./cmpvisualizadorestoque.vue?vue&type=script&lang=js&"
import style0 from "./cmpvisualizadorestoque.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports